import { __assign, __rest } from "tslib";
import * as React from 'react';
import { NavLink, Link } from 'react-router-dom';
/**
 * Represents a generalized anchor element that resolves either to a plain <a> or
 * a <NavLink> or a <Link> depending if the given `url` is absolute, relative or
 * exact.
 */
export var Anchor = function (_a) {
    var url = _a.url, nav = _a.nav, props = __rest(_a, ["url", "nav"]);
    return /^(https?|mailto|tel|fax):/.test(url) ? (React.createElement("a", __assign({ href: url }, props))) : nav ? (React.createElement(NavLink, __assign({ to: url, exact: nav === 'exact' }, props))) : (React.createElement(Link, __assign({ to: url }, props)));
};
//# sourceMappingURL=index.js.map